import { useContext, useRef } from 'react'
import { useStore } from 'react-redux'
import { LuReceipt } from 'react-icons/lu'
import { HiOutlinePrinter } from 'react-icons/hi'
import { Btn } from '../Btn'
import { GlobalContext } from '../../context/GlobalContext'
import { useCompany } from '../../hooks/useCompany'
import { api } from '../../api/api'
import { Toast } from '../../utils/Toast'
import { prepareNotaPrint, sendPrintNota } from '../../reporting/print'
import { SET_ORDERS, UPDATE_SELECT_ORDER } from '../../stores/reducers/OrderReducers'

export function OrderFiscalButton({ order }) {
  const { isAccess } = useContext(GlobalContext)
  const { configurations } = useCompany()
  const store = useStore()
  const pending = useRef(false)

  if (!order?.id || order.status === 'cancelado' || !isAccess('fiscal', 'emissao')) return null

  async function handleNota() {
    if (pending.current) return
    if (!order.response && localStorage.getItem('isModuleNota') !== 'true') {
      return Toast.warning('O módulo de emissão de notas fiscais não está habilitado. Para ativá-lo, entre em contato com o suporte.')
    }

    pending.current = true
    let printPreview
    try {
      printPreview = prepareNotaPrint(configurations.defaultCodePrint, configurations.defaultNamePrint)
      if (order.response) {
        await sendPrintNota({ idOrder: order.id }, configurations.defaultCodePrint, configurations.defaultNamePrint, printPreview)
        return
      }

      Toast.success('Estamos emitindo o cupom.')
      const { data } = await api.post('/nfce', { idOrder: order.id })

      // Preserve the issued note even if printing fails or another order is opened.
      const current = store.getState().order
      store.dispatch(SET_ORDERS(current.orders.map(item => item.id === order.id ? { ...item, response: data } : item)))
      if (current.orderSelect?.id === order.id) {
        store.dispatch(UPDATE_SELECT_ORDER({ response: data }))
      }

      Toast.success('Cupom emitido com sucesso.')
      await sendPrintNota({ idNota: data.idNota }, configurations.defaultCodePrint, configurations.defaultNamePrint, printPreview)
    } catch (error) {
      printPreview?.previewWindow?.close()
      if (!error?.response?.data?.message) {
        Toast.warning('Não foi possível concluir a operação fiscal. Tente novamente.')
      }
    } finally {
      pending.current = false
    }
  }

  return (
    <Btn
      text={order.response ? 'Imprimir nota fiscal' : 'Emitir nota fiscal'}
      icon={order.response ? <HiOutlinePrinter size={18} /> : <LuReceipt size={18} />}
      leftIcon
      click={handleNota}
      width={190}
    />
  )
}
